module.exports = __webpack_public_path__ + "static/img/rrrr_17.4eed740.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_17.png
// module id = c39h
// module chunks = 1